require("bootstrap-cookie-alert");